import { Box, DashboardModuleListItem, Image } from '@domain-group/suit-theme'

import { generateLogoUrl } from '@functions/adAccount'
import camelCaseToTitleCase from '@functions/utils/camelCaseToTitleCase'
import capitalizeString from '@functions/utils/capitalizeString'

import useAdAccount from '@hooks/useAdAccount'

interface AdChannelCardProps {
  adAccountGroupId: number,
  adAccountType: 'FacebookAdAccount' | 'FacebookPage' | 'GoogleAdAccount',
  adChannel: 'facebook' | 'google',
  marginTop?: string,
}

const AdChannelCard = (props: AdChannelCardProps) => {
  const { adAccountGroupId, adAccountType, adChannel, marginTop } = props

  const url = generateLogoUrl(adChannel)

  const {
    callbacks: {
      launchLinkAdAccountsModal,
    },
  } = useAdAccount()

  return (
    <Box
      border="1px solid"
      borderColor="lineColor"
      borderRadius={5}
      flexDirection="column"
      marginTop={marginTop}
    >
      <Box
        borderBottom="1px solid"
        borderColor="lineColor"
      >
        <Image backgroundSize="contain" height="112px" url={url} />
      </Box>

      <DashboardModuleListItem
        onClick={() => launchLinkAdAccountsModal({ adAccountGroupId, adAccountType, adChannel })}
        secondaryText={camelCaseToTitleCase(adAccountType)}
        title={capitalizeString(adChannel)}
      >
      </DashboardModuleListItem>
    </Box>
  )
}

export default AdChannelCard